import React from 'react';
import { PropTypes } from 'prop-types';
import EnrollmentAssignmentEvent from './EnrollmentAssignmentEvent';
import EnrollmentCreateEvent from './EnrollmentCreateEvent';
import EnrollmentEditEvent from './EnrollmentEditEvent';
import EnrollmentStatusEvent from './EnrollmentStatusEvent';
import { getMeaningfulChangeKeys } from './enrollmentTimelineEventUtils';

const EnrollmentTimelineEvent = ({ timelineEvent }) => {
  const meaningfulChangeKeys = getMeaningfulChangeKeys(timelineEvent.changes);
  const isCreateEvent = timelineEvent.action_type === 'create';
  const isStatusEvent = meaningfulChangeKeys.includes('enrollment_status');
  const isAssignedEvent = meaningfulChangeKeys.includes('assignee_id') && meaningfulChangeKeys.length === 1;

  if (isCreateEvent) {
    return <EnrollmentCreateEvent timelineEvent={timelineEvent} />;
  }

  if (isStatusEvent) {
    return <EnrollmentStatusEvent timelineEvent={timelineEvent} />;
  }

  if (isAssignedEvent) {
    return <EnrollmentAssignmentEvent timelineEvent={timelineEvent} />;
  }

  return <EnrollmentEditEvent timelineEvent={timelineEvent} />;
};

EnrollmentTimelineEvent.propTypes = {
  timelineEvent: PropTypes.object.isRequired,
};

export default EnrollmentTimelineEvent;
